// Phone-number normalization + validation. The default country is US because
// Twilio's toll-free + Sendblue lines are US-only; non-US users have to enter
// the +CC themselves and libphonenumber will accept the explicit prefix.
//
// The API still regex-validates `^\+\d{10,15}$` server-side as
// defense-in-depth — these helpers are the friendly client-side layer.

// libphonenumber-js's default export is the "min" metadata bundle (~75kB
// gzipped) covering ~50 countries. That's plenty since Inkling's Twilio
// toll-free + Sendblue lines are US-only and non-US users have to enter
// the +CC prefix themselves anyway.
import { parsePhoneNumberFromString } from "libphonenumber-js";

export function normalizePhone(input: string, defaultCountry: "US" = "US"): string {
  const trimmed = input.trim();
  if (!trimmed) return "";
  // Accept anything libphonenumber can parse: "(415) 530-1129", "415.530.1129",
  // "+1 415 530 1129", "+44 20 7946 0958". If parsing fails, fall back to the
  // raw digits so the validation step (below) catches and surfaces a friendly
  // error message rather than silently mangling the input.
  const parsed = parsePhoneNumberFromString(trimmed, defaultCountry);
  if (parsed?.isValid()) return parsed.number;
  return trimmed.startsWith("+") ? trimmed : `+${trimmed.replace(/[^\d]/g, "")}`;
}

export function isValidPhone(input: string, defaultCountry: "US" = "US"): boolean {
  const parsed = parsePhoneNumberFromString(input.trim(), defaultCountry);
  return Boolean(parsed?.isValid());
}
